import { Typography, Box, Stack, Grid,Link } from "@mui/material"
import React from "react";
import MiscLayout from "./miscLayout";

const AboutUsPage  =() =>{
    window.heap.track('About-us', {
        buttonName: 'About Us',
        category: 'Page view',
      });

    const tabs = [
        {
            name:"Introduction",
            component:<Introduction />
        },
        {
            name:"Purpose",
            component:<Purpose />
        },
        {
            name:"RealX DNA",
            component:<RealXDNA />
        },    
        {
            name:"Team",
            component:<Team />
        },
        {
            name:"Friends & Evangelists",
            component:<Friends />
        },
        {
            name:"Advisers",
            component:<Adviser />
        },
       
    ]
    return(
        <MiscLayout tabs={tabs} title={"About Us"} />
    )
}
export default AboutUsPage


const Introduction = () =>{
    return(
        <Stack spacing={1.5}>
            <Typography variant="aboutHeading2">Introduction</Typography>
            <Typography variant="body3">
                RealX is a Digital Assets platform that enables investment in Real-World Assets as Digital Assets with legal rights to such ownership. 
                <br /><br/>RealX began its journey by introducing fractional ownership of properties as Digital Assets. 
                RealX enables people to invest smaller amounts to become co-owners of high yield and high return properties that were not accessible to many owing to the high price of owning full property. 
                Aside of direct registered co-ownership, RealX also provides an option for smaller investments in these properties being offered as Property Tokens (NFTs). The Property Tokens will mean a proportionate direct ‘Right to Registered Co-Ownership’ (RRO). 
                So, a Token holder can exhaust the Token to become a Direct Co-Owner of the property. 
                <br /><br/>Built after years of work behind it and on base legal framework, RealX is the first such platform in the world that can offer property Tokens with direct, unencumbered, and proportionate rights on property with full legal enforceability. 
                These property tokens, being Digital Assets, can offer better liquidity and exit options when they are listed on various credible Digital Asset exchanges in the world. 
                <br /><br/>Real Estate is the most complex of assets to be digitized and tokenized on Distributed Ledger Technology to create a Digital Asset with Legal Rights. After solving the most difficult use case for Digital Assets, RealX is gearing up for 
                adding more exciting Real-World assets to its line of products in times to come like private equity, bullion and more innovative assets that we will develop in time. 
            </Typography>
        </Stack>
    )
}

const Purpose = () =>{
    return( 
        <Stack spacing={1.5}>
            <Typography variant="aboutHeading2">Purpose</Typography>
            <Typography variant="body3">
                RealX strives to create Digital Asset products and solutions that enable everyone to have equitable access to investment opportunities. 
                To ensure that our customers’ interests are protected, we develop our solutions after a deep study of the legal framework and then bring forth the best in terms of technology to ensure we can provide seamless, legal, and digital products to them. 
                <br /><br/>We wanted to bring in best in class process, governance and technology for you. While, we cannot protect you from inherent risks associated with owning property, but we can surely work to create a trusted environment for you to participate. 
                <br /><br/>Our goal is to ensure that there is a maker-checker in everything we do. As a principle, we ensure that no entity has significant control over everything. Here's how we have implemented this: 
                <br />• Enable only vetted, clean propositions for you - with external Due Diligence done by experienced law firms 
                <br />• Let a Bank handle your money (through an escrow account as per RBI guidelines) - and not RealX touching it 
                <br />• Let an independent entity - <span style={{fontWeight:500}}>Not RealX</span>, hold your Property Title 
                <br />• Maintain the registry for your property holdings on an immutable and cryptographically secure system (PropChain) - bringing in benefit of the best technology the world has for a registry system. 
                <br />• Let a competent Property Management firm manage the day-to-day administration for you - so that you can simply enjoy the benefits without any hassles
            </Typography>
        </Stack>
    )
}

const RealXDNA = () =>{
    return(
        <Stack spacing={4}>
            <Stack spacing={1.5}>
                <Typography variant="aboutHeading2">Management Experience</Typography>
                <Typography variant="body3">
                    RealX core team have a combined 100+ years experience in the real estate, capital markets and equities market. The co-founders of RealX had earlier co-founded GREX (a private market platform to invest in high growth companies) - the only platform to have been evaluated and cleared by the regulator to operate.
                </Typography>
            </Stack>
            <Stack spacing={1.5}>
                <Typography variant="aboutHeading2">Fintech and Security Market Background</Typography>
                <Typography variant="body3">
                Our DNA is that of securities market which is highly regulated and investor protection is at the core. We believe that the time is ripe for real estate to be as easy an asset to purchase and sale as shares and mutual funds with all the legal and financial transparency and disclosures that exist in the equities market today.
                </Typography>
            </Stack>
            <Stack spacing={1.5}>
                <Typography variant="aboutHeading2">Next Generation Model</Typography>
                <Typography variant="body3">
                When it comes to Fractional real estate the model that exists today is based on the SPV (Special Purpose Vehicle) structure. Under the SPV structure, the investor gets to invest in a SPV with a minimum ticket size of 25 lakhs or above. For each property a new SPV is created and under this structure, company law applies which creates restrictions as well as tax inefficiencies. 
                <br />In the RealX proprietary model, there is no intermediate layer. Investors are the DIRECT co-owners in the property and are listed in the sale deed of the property along with the fractions they hold.
                </Typography>
            </Stack>
        </Stack>
    )
}

const Team = () =>{
    const team = [
        {
            name:"Manish Kumar",
            image:"/assets/images/teams/Manish.png",
            position:"Co-founder and CEO",
            desc:"Manish is disruptive serial entrepreneur with 21 years of experience behind him. He is driven to build platforms for participative growth for all stakeholders. Considered a Fintech thought leader, Manish is called upon to share his thoughts on electronic media as well as print and digital media. He is also regularly invited as speaker or moderator at events, both domestic and international. He is also member of few consultative committees on BlockChain. He co-leads the South Asia regional chapter of Global Impact Fintech (GIFT), a global fintech thinktank and is also on VCPE Committee of Bombay Chambers of Commerce and Industry (BCCI)."
        },
        {
            name:"Neera Inamdar",
            image:"/assets/images/teams/NeeraInamdar.png",
            position:"Co-founder and COO",
            desc: (<>
                With a professional career spanning over 20 years, Neera has handled range of roles and domains from critical time sensitive role to BD, Marketing, Company engagement, Corporate & Govt Relations. She joined a Fintech company GREX which was running a Private Market platform for startup investments, reporting and exits. She joined the co-founder of GREX when they together co-founded RealX – a fractional ownership platform for properties.
                <br /><br />Aside of her professional responsibilities, she also co-leads the South Asia chapter of a global fintech think tank organization called GIFT (or Global Impact Fintech). She is also involved with one of the largest State-run incubators called KSUM (Kerala Startup Mission) & MARG StartupIndia as a Mentor.
                <br /><br />She loves customer facing & BD roles. However, her career has exposed her to deeper understanding and reasonable expertise over various & varied inward corporate functions like operations, finance, legal & compliance as well.
            </>)
        },
        // {
        //     name:"Devang Sheth",
        //     image:"/assets/images/teams/DevangSheth.png",
        //     position:"Co-founder and CBO",
        //     desc: (<>
        //         Devang has over 30 years of experience in various senior management and key advisory capacities in the field of Engineering, Real Estate, Marketing, Business Development, Trade and Media across North America, UAE and India. He is currently focused on Real Estate and Finance.
        //         <br /><br /> Through his international and domestic career his clients included International companies such as Boeing, Walmart, Black & Decker, Phillips, Southern Pacific Railroad and many more. He also currently serves as Chairman of Indi Enterprise, a multifaceted media group, providing media services to clients such as British Gas, Pfizer, Citibank, Bank of America, Novartis, Rustomjee, Mastek and others.
        //         <br /><br /> In his prior experience he served as the Founder and Chairman of <a href="https://ecoper.com" target="_blank" rel="noopener noreferrer">ecoper.com</a> which was voted the best copper portal by D & B.
        //         <br /><br /> He holds a B.E. in Civil Engineering from Mumbai University, an M.S. in Environmental Engineering from South Dakota School of Mines(USA) and a Diploma in Marketing from University of California, Riverside, California.
        //     </>)
        // },
        {
            name:"Kallol kanungo",
            image:"/assets/images/teams/Kallolkanungo.webp",
            position:"",
            desc: (<>           
                A Senior Technology Business Executive with extensive global experience. Telecom, Datacentre, Retail, BFSI, BPO, IT Services, Government, Education, Healthcare and Large Enterprises are his main domain areas where he has been engaged largely in the last 20 years.
                He is an entrepreneur, an investor, advisor and a  Start-up specialist who has built two start-ups and exited it  since 2012 and the  third one he built in 2019 in the future tech area. His forte lies in lighting up New business from ground up to formidable size, building Joint ventures and partnership ecosystem to deliver large size business.
            </>)
        },
      
        {
            name:"Arpit Gosain",
            image:"/assets/images/teams/Arpit.jpg",
            position:"",
            desc:"With a background in Electrical and Electronics Engineering and as an entrepreneur in the hyperlocal delivery space, he brings five years of startup business development experience. His tenacity is not just professional but also personal, as a state-level football player and an amateur Mixed Martial Artist, he combines technological fluency, entrepreneurial expertise, and athletic discipline thus creating a well-rounded skill set."
        },
        {
            name:"Vishal Dorge",
            image:"/assets/images/teams/vishalDorge.webp",
            position:"",
            desc:"Vishal serves as the Technical Lead, overseeing the entire technology team and playing an active role in product development. With a B.Tech in Computer Science and deep expertise in web development and cloud computing, he brings technical depth with a forward-thinking mindset and hands-on experience to the organization. Outside of work, he follows a path of inner growth, drawing from his spiritual interests to lead with clarity and purpose."
        },
       
       
    ]
    return(
        <Stack spacing={2}>
            <Typography variant="aboutHeading2">Team</Typography>
            <Box>
                <Grid container maxWidth={'100%'} rowGap={8} columnSpacing={{md:4}} >
                    {
                        team.map((e,i)=>{
                            return(
                                <Grid item md={12} xs={12} >
                                    <Stack direction={'row'} spacing={3} >
                                    <Box
                                            sx={{
                                                position: 'relative',
                                                minHeight: '100%',
                                            }}
                                        > 
                                    <Box
                                        component="img"
                                        sx={{
                                        height: {md:163,xs:80},
                                        width: {md:163,xs:80},
                                        maxHeight: { md: 163, xs: 80 },
                                        maxWidth: { md: 163, xs: 80 },
                                        minHeight: { md: 163, xs: 80 },
                                        minWidth: { md: 163, xs: 80 },
                                        objectFit: "cover",
                                        borderRadius:'4px',
                                        position: 'sticky',
                                        top: 150, 
                                        }}
                                        // alt="The house from the offer."
                                        src={e.image}
                                    />
                                    </Box>
                                        <Stack spacing={1.5}>
                                                <Box>
                                                    <Typography variant="teamName" >{e.name}</Typography>
                                                    <Typography variant="subtitle2">{e.position}</Typography>
                                                </Box>
                                                <Typography variant="teamDesc">{e.desc}</Typography>
                                        </Stack>
                                    </Stack>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Box>
        </Stack>
    )
}


export const Friends=()=>{
    
const data = [
    {
        img: "/assets/images/friends/PrahladGirish.webp",
        name:"Prahlad Giri",
        link:'https://www.linkedin.com/in/prahladgirinepal/'
     },
    {
       img: "/assets/images/friends/GrReddy.webp",
       name:"G R Reddy",
       link:'https://www.linkedin.com/authwall?trk=bf&trkInfo=AQGbwmEkaUlG4wAAAY7xaZuwBiMDHIqfJoLkfnKmQuDYdPN9RFW_iDvhcwaEjr3d7BBTTEm7hY7K2Ne3y-5zjHVjp9pPt7_CdetphAmXbllmB6IJP13oz-za9YKJGrB03QIWdpc=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Fgrreddy%3Futm_source%3Dshare%26utm_campaign%3Dshare_via%26utm_content%3Dprofile%26utm_medium%3Dandroid_app'

    },
   {
        img: "/assets/images/friends/anubhavTiwari.webp",
        name:"Anubhav Tiwari",
        link:"https://www.linkedin.com/in/anubhavtiwarivicky"
     },
   
    {
       img: "/assets/images/friends/SudinBarokar.webp",
       name:"Sudin Barokar",
       link:'https://www.linkedin.com/search/results/all/?keywords=Sudin%20Baraokar&origin=GLOBAL_SEARCH_HEADER&sid=2ZZ'
    },
    {
       img: "/assets/images/friends/MalikKhanKotadia.webp",
       name:"MalikKhan Kotadia",
       link:'https://www.linkedin.com/search/results/all/?fetchDeterministicClustersOnly=true&heroEntityKey=urn%3Ali%3Afsd_profile%3AACoAAAD65gIBBVmE2kbEPVbcyVkbKbjouX4dM_c&keywords=malik%20khan%20kotadia&origin=RICH_QUERY_SUGGESTION&position=0&searchId=faa74186-f495-4ef7-98e1-5dff102a6139&sid=U7L&spellCorrectionEnabled=false'
    },
   ];
   
    return(
        <Grid container spacing={3} justifyContent={'start'}>

            {data.map((item, index) => {
                return (
                    <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2}>
                        <Box style={{ position: 'relative', width: '100%', height: 'auto' }}>

                        <img src={item.img} alt="Image 1" style={{ width: '100%', height: 'auto' ,borderTopLeftRadius:'12px',borderTopRightRadius:'12px'}} />
                            <Link href={item.link} target="_blank" rel="noopener noreferrer">
                                <img src={'/assets/images/friends/Lnicon.png'} alt="LinkedIn" style={{ position: 'absolute', top: -3, right: -3, width: '25px', height: '25px',borderRadius:'20%'}} />
                            </Link>
                        </Box>
                        <Typography sx={{
                            borderTop: "3px solid #ff8c16",
                            borderBottomLeftRadius:"12px",
                            borderBottomRightRadius:"12px",
                            bgcolor: '#0c657c',
                            color: '#fff',
                            textAlign: 'center',
                            padding: '12px 3px',
                            fontWeight: 600,
                            fontSize: { xl: '15px', lg: '14px', md: '14px', sm: '14px', xs: '14px' }
                        }}>
                            {item.name}
                        </Typography>
                    </Grid>
              )
            })
           } 
        </Grid>
    )
}

const Adviser = () =>{
    const team = [
        {
            name:"Rakesh Kumar",
            image:"/assets/images/advisers/Rakeshkumar.webp",
            position:"",
            desc:(<>Rakesh Kumar is a visionary entrepreneur and senior executive with over 25 years of experience across energy (hydrocarbons and renewables), real estate, infrastructure, telecommunications, and retail sectors.<br/><br/> His career has been driven by two core themes: Strategic Planning and High-Speed Execution. He has worked with some of the largest and most respected organizations in the world including Shell, Walmart, Jio, Reliance Petroleum, and Exide, as well as with government and entrepreneurial ventures. <br/><br/>His deep domain knowledge in real estate acquisition, energy strategy, and corporate affairs makes him uniquely positioned to lead and support transformative initiatives. From conceptualizing retail networks to executing greenfield telecom infrastructure, his experience spans from ground-level implementation to boardroom advisory</>)
        },
        {
            name:"Bhavya Bagrecha",
            image:"/assets/images/advisers/bhavya.webp",
            position:"",
            desc: (<>Bhavya Bagrecha is Co-founder of Aritraa Group, with expertise in Private Equity and Investment Management. He has 22+ years of experience in Fund setup, business strategy, finance, start-up advisory, taxation, and corporate governance.<br/><br/> His business interests include Oil & Gas, Logistics, Wayside Amenities, Telecom Infrastructure, and Real Estate. Bhavya holds strong background in finance and management honed through his professional work experience as well as multiple professional credentials as a CA, CS, and CMA along with MCom (gold medallist).<br/><br/> He has held key roles in leading investments and REIT strategies across his CXO roles in various organisations including Landmark Capital and Milestone Capital where he has lead investments across commercial, residential, warehousing, co-living, and IT Parks.</>)
        },
       
       
    ]
    return(
        <Stack spacing={2}>
            <Typography variant="aboutHeading2">Advisers</Typography>
            <Box>
                <Grid container maxWidth={'100%'} rowGap={8} columnSpacing={{md:4}} >
                    {
                        team.map((e,i)=>{
                            return(
                                <Grid item md={12} xs={12} >
                                    <Stack direction={'row'} spacing={3} >
                                    <Box
                                            sx={{
                                                position: 'relative',
                                                minHeight: '100%',
                                            }}
                                        > 
                                    <Box
                                        component="img"
                                        sx={{
                                        height: {md:163,xs:80},
                                        width: {md:163,xs:80},
                                        maxHeight: { md: 163, xs: 80 },
                                        maxWidth: { md: 163, xs: 80 },
                                        minHeight: { md: 163, xs: 80 },
                                        minWidth: { md: 163, xs: 80 },
                                        objectFit: "cover",
                                        borderRadius:'4px',
                                        position: 'sticky',
                                        top: 150, // Adjust based on your layout/header
                                        }}
                                        // alt="The house from the offer."
                                        src={e.image}
                                    />
                                    </Box>
                                     
                                        <Stack spacing={1.5}>
                                                <Box>
                                                    <Typography variant="teamName" >{e.name}</Typography>
                                                    <Typography variant="subtitle2">{e.position}</Typography>
                                                </Box>
                                                <Typography variant="teamDesc">{e.desc}</Typography>
                                        </Stack>
                                    </Stack>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Box>
        </Stack>
    )
}